import type { PopOverMenuOptionProps } from './types';
import { Icon } from 'Components/shared/Icon';
import React from 'react';
import { Styled } from './index.styles';

export const PopOverMenuOption: React.FC<PopOverMenuOptionProps> = ({
  children,
  destructive = false,
  disabled = false,
  href,
  icon,
  onClick,
  testid,
}) => (
  <div>
    <Styled.Button
      {...(href && { href, target: '_blank', rel: 'noreferrer' })}
      {...(onClick && { onClick })}
      $destructive={destructive}
      $disabled={disabled}
      $hasIcon={!!icon}
      data-testid={testid}
      compact
      basic
    >
      {icon && (
        <Icon
          icon={icon}
          testId={`${testid}-icon`}
          size="lg"
          className="!text-inherit"
        />
      )}
      {children}
    </Styled.Button>
  </div>
);
